// Servicio para interactuar con la API de Deezer

const RAPIDAPI_KEY = '9ec3632ffcmsh57345cb6b7b4d10p1441a8jsn08ebbdefa195';
const RAPIDAPI_HOST = 'deezerdevs-deezer.p.rapidapi.com';

class DeezerService {
  // Buscar una canción específica
  async searchTrack(trackName, artistName) {
    try {
      const query = `${trackName} ${artistName}`;
      const response = await fetch(
        `https://${RAPIDAPI_HOST}/search?q=${encodeURIComponent(query)}&limit=1`,
        {
          method: 'GET',
          headers: {
            'X-RapidAPI-Key': RAPIDAPI_KEY,
            'X-RapidAPI-Host': RAPIDAPI_HOST
          }
        }
      );

      if (!response.ok) {
        console.warn(`⚠️ Deezer API error: ${response.status}`);
        return null;
      }

      const data = await response.json();

      if (data.data && data.data.length > 0) {
        const track = data.data[0];
        return {
          id: track.id,
          title: track.title,
          artist: track.artist?.name,
          album: track.album?.title,
          preview: track.preview, // Preview URL de 30 segundos
          cover: track.album?.cover_xl || track.album?.cover_big || track.album?.cover_medium,
          coverMedium: track.album?.cover_medium,
          coverSmall: track.album?.cover_small,
          duration: track.duration,
          link: track.link
        };
      }

      return null;
    } catch (error) {
      console.error(`⚠️ Error buscando "${trackName}" en Deezer:`, error);
      return null;
    }
  }

  // Buscar múltiples canciones
  async searchTracks(query, limit = 100) {
    try {
      const response = await fetch(
        `https://${RAPIDAPI_HOST}/search?q=${encodeURIComponent(query)}&limit=${limit}`,
        {
          method: 'GET',
          headers: {
            'X-RapidAPI-Key': RAPIDAPI_KEY,
            'X-RapidAPI-Host': RAPIDAPI_HOST
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      return {
        data: data.data,
        total: data.total || data.data.length
      };

    } catch (error) {
      console.error('Error buscando canciones:', error);
      return { data: [], total: 0 };
    }
  }

  // Buscar artistas
  async searchArtists(query, limit = 150) {
    try {
      const response = await fetch(
        `https://${RAPIDAPI_HOST}/search/artist?q=${encodeURIComponent(query)}&limit=${limit}`,
        {
          method: 'GET',
          headers: {
            'X-RapidAPI-Key': RAPIDAPI_KEY,
            'X-RapidAPI-Host': RAPIDAPI_HOST
          }
        }
      );

      const data = await response.json();
      return {
        data: data.data,
        total: data.total || data.data.length
      };

    } catch (error) {
      console.error('Error buscando artistas:', error);
      return { data: [], total: 0 };
    }
  }

  // Buscar álbumes
  async searchAlbums(query, limit = 150) {
    try {
      const response = await fetch(
        `https://${RAPIDAPI_HOST}/search/album?q=${encodeURIComponent(query)}&limit=${limit}`,
        {
          method: 'GET',
          headers: {
            'X-RapidAPI-Key': RAPIDAPI_KEY,
            'X-RapidAPI-Host': RAPIDAPI_HOST
          }
        }
      );

      const data = await response.json();
      return {
        data: data.data,
        total: data.total || data.data.length
      };

    } catch (error) {
      console.error('Error buscando álbumes:', error);
      return { data: [], total: 0 };
    }
  }
}

// Exportar una única instancia
export const deezerService = new DeezerService();
